<template>
    <svg :class="className" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M5 12H19" stroke="#EBF0FC" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconMinus',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>